module.exports = __webpack_public_path__ + "img/Plus.ccd6be21.svg";